import { connect } from 'react-redux'
import { setTargetComponent } from 'Modules/lookups/actions'
import AppLinkMobileCtrl from './AppLinkMobileCtrl'

const actions = {
  setTargetComponent,
}

export default connect(state => ({
  disableNewTab: state.app.disableNewTab || state.app.mobileBrowser,
  isMobileApp: state.app.isMobileApp,
}), actions)(AppLinkMobileCtrl)
